import translations from './translations'

translations.add('is', {
    iAgreeWith: 'Ég samþykki',
    termsAndConditions: 'skilmála og skilyrði',
    pay: 'BORGA'
})
